import {
  AppBar,
  Autocomplete,
  Avatar,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Drawer,
  Grid,
  IconButton,
  InputAdornment,
  Rating,
  Stack,
  TextField,
  Toolbar,
  Tooltip,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Close } from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
import ProductDetails from "../Products/ProductDetails";


function LandingSalesComp() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { globalUser, globalCustomers,
    addtoCart, removeFromCart,
    selectedItems, setSelectedItems,
    setPageHeader, selectedSalesType, setSelectedSalesType, globalStores, globalToken } =
    useContext(ShoppingCartContext);
  const [store, setStore] = useState(globalStores && globalUser?.Store !== 0 ? globalStores.filter((st) => parseInt(st.Id) === parseInt(globalUser?.Store))
    .length > 0 &&
    globalStores.filter(
      (st) => parseInt(st.Id) === parseInt(globalUser?.Store)
    )[0]?.Name : globalStores[0]?.Name);
  const [productsList, setProductsList] = useState([]);
  const [filteredProductsList, setFilterProductsList] = useState([]);
  const [providerOrProductCategoriesList, setProviderOrProductCategoriesList] =
    useState([]);

  const [selectedCategory, setSelectedCategory] = useState();
  const [customer, setcustomer] = useState();


  const [searchText, setSearchText] = useState("");
  const [openItemCategoryDrawer, setOpenItemCategoryDrawer] = useState(false);
  const [openCustomerDrawer, setOpenCustomerDrawer] = useState(true);

  const [filteredcustomer, setFilteredcustomer] = useState(globalCustomers);
  const [searchcustomer, setSearchcustomer] = useState("");
  let history = useNavigate();

  const toggleItemCateogyDrawer = () => {
    setOpenItemCategoryDrawer(!openItemCategoryDrawer);
  };
  const toggleCustomerDrawer = () => {
    setOpenCustomerDrawer(!openCustomerDrawer);
  };
  const loadstockBalancesList = () => {
    axios.get("/stockBalances/getByParentAndStore?Parent=" + globalUser?.Parent + "&Store=" + (globalStores.filter(st => st.Name === store)[0]?.Id), {
      headers: {
        token: globalToken,
      },
    })
      .then(response => {
        if (response.data.data) {
          setProductsList(response.data.data);
          setFilterProductsList(response.data.data);

        } else {
          alert('log out and log in again')
        }
      })

  };

  useEffect(() => {
    if (!globalUser) {
      navigate('/');
      return;
    }
    try {
      setcustomer("")
      setPageHeader('Sales Landing')
      setFilteredcustomer(globalCustomers)
      setSelectedSalesType(selectedSalesType && selectedSalesType.length > 0 ? selectedSalesType : "Order")
    } catch (err) {

    }

  }, []);
  useEffect(() => {
    loadstockBalancesList();
  }, [store])
  return (
    <Stack mt={1}>
      <AppBar position="static" backgroundColor={theme.palette.primary.contrastText} >
        <Toolbar sx={{ bgColor: theme.palette.primary.contrastText }}>
          <Grid container>
            <Grid item xs={12} md={6}>

              <TextField
                size="small"
                variant="outlined"
                //label={t("search")}
                value={searchText}
                sx={{ width: '95%', borderRadius: '25px', border: 1 }}
                onChange={(e) => {
                  setSearchText(e.target.value.toLowerCase());
                  var searchTem = e.target.value.toLowerCase();
                  setProductsList(
                    filteredProductsList.filter((item) => {
                      return (
                        item.Name.toLowerCase().match(
                          new RegExp(searchTem, "g")
                        ) ||
                        /* (item.BrandName != null &&
                           item.BrandName.toLowerCase().match(
                             new RegExp(searchTem, "g")
                           )) ||
                          (item.Category != null &&
                           item.Category.toLowerCase().match(
                             new RegExp(searchTem, "g")
                           )) ||
                         (item.Abbreviation != null &&
                           item.Abbreviation.toLowerCase().match(
                             new RegExp(searchTem, "g")
                           )) || */
                        (item.Description != null &&
                          item.Description.toLowerCase().match(
                            new RegExp(searchTem, "g")
                          )) ||
                        (item.CustomerName != null &&
                          item.CustomerName.toLowerCase().match(
                            new RegExp(searchTem, "g")
                          ))
                      );
                    })
                  );
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Button
                        sx={{ color: theme.palette.primary.contrastText }}
                        endIcon={<MenuIcon />}
                        onClick={() => toggleItemCateogyDrawer()}
                      />
                      <SearchIcon sx={{ color: theme.palette.primary.color }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    searchText && searchText.length > 0 &&
                    <InputAdornment position="end">
                      <Close sx={{ color: "white" }} onClick={() => {
                        setSearchText("")
                        setProductsList(filteredProductsList)
                      }} />
                    </InputAdornment>

                  ),


                  style: { color: 'white' }
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography color={theme.palette.primary.contrastText} variant="h5">
                {!(selectedCategory == null) && selectedCategory.length > 0 ? (
                  <span>
                    {" "}
                    {selectedCategory}
                    {" ("} {productsList.length} {" Products)"}
                    <Tooltip title={t("clear selection")}>
                      <IconButton
                        variant="standard"
                        style={{ border: 1 }}
                        onClick={() => {
                          setSearchText("");
                          setProductsList(filteredProductsList);
                          setSelectedCategory("");
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </Tooltip>
                  </span>
                ) : globalUser &&
                  globalUser.length > 0 &&
                  globalUser.Type === "Retailer" ? (
                  t("all providers") + " (" + productsList.length + " Products)"
                ) : (
                  t("all categories") +
                  " (" +
                  productsList.length +
                  " Products)"
                )}
              </Typography>
              <Typography variant="h6" color={theme.palette.primary.contrastText} ml={8}>
                {!(searchText == null) && searchText.length > 0 && (
                  <span> Searched with : {searchText}</span>
                )}
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={openItemCategoryDrawer}
        onClose={() => setOpenItemCategoryDrawer(false)}
      >
        <Button
          variant="standard"
          endIcon={<ChevronLeftIcon />}
          onClick={() => toggleItemCateogyDrawer()}
        >
          Categories
        </Button>

        <nav>
          <ul>
            {providerOrProductCategoriesList &&
              providerOrProductCategoriesList.map((item) => {
                return (
                  <li key={item.Id + item.Name} style={{ fontSize: "10px" }}>
                    <Button
                      startIcon={
                        <Avatar
                          src={
                            item.Image != null && item.Image.length > 0
                              ? item.Image.split(",")[0]
                              : "/Images/ProductCategoriesPics/default.png"
                          }
                        />
                      }
                      variant="standard"
                      value={item.Id}
                      onClick={(e) => {
                        setSelectedCategory(item.Name);
                        setProductsList(
                          filteredProductsList.filter((tt) => {
                            return globalUser.Type === "Retailer"
                              ? tt.Customer === e.target.value
                              : tt.Category === e.target.value;
                          })
                        );
                      }}
                    >
                      {item.Name}
                    </Button>{" "}
                  </li>
                );
              })}
          </ul>
        </nav>
        {/*  <List sx={{ bgcolor: "#1976d2", color: "#fff", fontSize:"5px" }}>
          {providerOrProductCategoriesList &&
            providerOrProductCategoriesList.map((item) => {
              return (
                <ListItem>
                  <FormControlLabel
                    control={
                      <Checkbox 
                      checked={false} 
                      onChange={(event) => {}} />
                    }
                    label= {item.Name}
                  />

                 <Avatar
                    src={
                      item.Image != null && item.Image.length > 0
                        ? item.Image.split(",")[0]
                        : "/Images/ProductCategory/default.png"
                    }
                  /> 
                </ListItem>
              );
            })}
        </List> */}
      </Drawer>
      <Grid container>
        <Grid item xs={12} md={2} pt={2} >
          <Grid container>
            <Grid item xs={6}>
              <Autocomplete
                disablePortal
                selectOnFocus
                autoHighlight
                contentEditable={false}
                value={selectedSalesType}
                id="Type"
                /* onSelectCapture={(e) => {
                  setSelectedSalesType(e.target.value);
                }} */
                onChange={(event, newValue) => {
                  setSelectedSalesType(newValue); // ✅ updates state
                }}
                options={[
                  "Draft",
                  "Order",
                  "Direct",
                  "Direct D&P",
                ]}
                sx={{
                  width: "95%",
                  marginBottom: 2,
                  marginTop: 5,
                  borderRadius: "25%",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Voucher Type"
                    variant="standard"
                  //error={!fromAirport ? true : false}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                disablePortal
                selectOnFocus
                autoHighlight
                contentEditable={false}
                value={store}
                id="Store"
                /* onSelectCapture={(e) => {
                  setSelectedSalesType(e.target.value);
                }} */
                onChange={(event, newValue) => {
                  setStore(newValue); // ✅ updates state
                }}
                options={globalStores ? globalStores.map((st) => st.Name) : ['']}
                sx={{
                  width: "95%",
                  marginBottom: 2,
                  marginTop: 5,
                  borderRadius: "25%",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Store"
                    variant="standard"
                  //error={!fromAirport ? true : false}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} >

              <span style={{ fontSize: 14, fontWeight: 'bold' }}>
                {"Customer : " + customer} {customer + (customer && customer.length > 0) && <Close sx={{ color: "green", height: 20, marginLeft: 1, marginBottom: -1 }} onClick={() => {
                  setcustomer("")
                  setSearchcustomer("")
                }} />}</span>
              <TextField
                size="small"
                variant="outlined"
                label={customer ? customer : 'search customer'}
                value={searchcustomer}
                sx={{ width: '95%', borderRadius: '25px', marginTop: 1, border: 0 }}
                onChange={(e) => {
                  setSearchcustomer(e.target.value.toLowerCase());
                  var searchTem = e.target.value.toLowerCase();
                  setFilteredcustomer(
                    globalCustomers.filter((item) => {
                      return (
                        item.CustomerName.toLowerCase().match(
                          new RegExp(searchTem, "g")
                        ) /*||
                      (item.BrandName != null &&
                        item.BrandName.toLowerCase().match(
                          new RegExp(searchTem, "g")
                        )) ||
                       (item.Category != null &&
                        item.Category.toLowerCase().match(
                          new RegExp(searchTem, "g")
                        )) ||
                      (item.Abbreviation != null &&
                        item.Abbreviation.toLowerCase().match(
                          new RegExp(searchTem, "g")
                        )) || 
                      (item.Description != null &&
                        item.Description.toLowerCase().match(
                          new RegExp(searchTem, "g")
                        ))||
                        (item.CustomerName != null &&
                          item.CustomerName.toLowerCase().match(
                            new RegExp(searchTem, "g")
                          ))*/
                      );
                    })
                  );
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Button
                        variant="standard"
                        endIcon={<MenuIcon sx={{ color: theme.palette.primary.main }} />}
                        onClick={() => toggleCustomerDrawer()}
                      />
                      <SearchIcon sx={{ color: theme.palette.primary.contrastText }} />
                    </InputAdornment>

                  ),
                  endAdornment: (
                    searchcustomer && searchcustomer.length > 0 &&
                    <InputAdornment position="end">
                      <Close sx={{ color: "green" }} onClick={() => {
                        setSearchcustomer("")
                        setFilteredcustomer(globalCustomers)
                      }} />
                    </InputAdornment>

                  ),


                  style: { color: 'green' }
                }}
              />
            </Grid>
            <Grid item bgcolor="primary.main" display={{ xs: openCustomerDrawer ? 'block' : 'none', md: 'block' }} xs={12} >
              <nav>
                <ul style={{ textAlign: 'left', backgroundColor: "white", color: "black" }}>
                  {filteredcustomer &&
                    filteredcustomer.map((item) => {
                      return (
                        <li key={item.Customer} style={{ fontSize: "10px" }}>
                          <Button
                            startIcon={
                              <Avatar
                                src={
                                  item.Logo != null && item.Logo.length > 0
                                    ? item.Logo.split(",")[0]
                                    : "/Images/ProductCategoriesPics/default.png"
                                }
                              />
                            }
                            variance="standard"
                            value={item.Customer}
                            onClick={(e) => {
                              setcustomer(item.CustomerName);
                              setSearchcustomer(item.CustomerName)
                              toggleCustomerDrawer();
                            }}
                          >
                            {item.CustomerName}
                          </Button>{" "}
                        </li>
                      );
                    })}
                </ul>
              </nav>
            </Grid>

          </Grid>
        </Grid>
        <Grid item xs={12} md={10}>
          <Grid container m={1} spacing={2} width="100%" >

            {productsList.length > 0 &&
              productsList.map((product, index) => {

                return (
                  <Grid item display={{ xs: openCustomerDrawer ? 'none' : 'block', md: 'block' }} key={product.Item + product.Customer} xs={11} md={4} lg={3}>

                    {/*    <Badge 
                     badgeContent={
                      selectedItems && selectedItems.length && selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales"===item.Type) && (item.CustomerName===customer)))
                     .length >0 ?
                      selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales"===item.Type) && (item.CustomerName===customer)))[0].Quantity:0} 
                     color="secondary" 
                     invisible={selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales"===item.Type) && (item.CustomerName===customer)))
                     .length <= 0?true:false}
                     > */}
                    <Card sx={{ borderRadius: 8, boxShadow: 3, width: '100%' }} >

                      <CardHeader
                        avatar={
                          <Avatar
                            src={
                              product.Picture != null &&
                                product.Picture.length > 0
                                ? product.Picture.split(",")[0]
                                : "/Images/ProductsPics/default.png"
                            }
                          />
                        }
                        className="CardHeader"
                        title={product.Name.substring(0, 20)}
                        subheader={product.CategoryName}
                      />

                      <CardMedia
                        component="img"
                        height="100px"
                        sx={{
                          padding: "0.2em 0.2em 0 0.2em",
                          objectFit: "fill",
                        }}
                        image={
                          product.Picture != null && product.Picture.length > 0
                            ? product.Picture
                            : "/Images/Products/default.png"
                        }
                        alt={product.Description}
                      />
                      <CardContent>
                        {/*  <Typography variant="body2" align="left">
                          customer.: {product.CustomerName}
                        </Typography> */}
                        <Typography variant="body2" align="left">
                          Desc.: {product.Description}
                        </Typography>
                        {!(product.Price === "0.00") ? (
                          <>
                            <Typography variant="body2" align="left">
                              <Stack direction='row'>
                                <Typography variant="body3" sx={{ alignItems: 'flex-start' }}>
                                  Price :{product.Price && product.Price > 0 ? product.Price : 0}
                                </Typography>
                                <Typography variant="body3" sx={{ alignItems: "flex-end", flex: 1, textAlign: 'right', marginRight: 2 }} >
                                  Inventory :{product.Quantity && product.Quantity > 0 ? product.Quantity : 0}
                                </Typography>
                              </Stack>


                              {selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))
                                .length > 0 ? (
                                <div>
                                  <Button
                                    variant="contained"
                                    sx={{ backgroundColor: 'red', color: 'white' }}
                                    size="small"
                                    mt={1}
                                    onClick={() => {
                                      removeFromCart({
                                        Id: 0,
                                        Type: "Sales",
                                        Item: product.Item,
                                        Name: product.Name,
                                        Quantity: 1,
                                        UnitPrice: product.Price,
                                        TotalPrice: product.Price * 1,
                                        Customer: (selectedSalesType === "Draft" || selectedSalesType === "Request") ? 0 : globalCustomers.filter(asup => asup.CustomerName === customer)[0]?.Customer,
                                      });
                                    }}
                                  >
                                    {" "}
                                    {t("remove")}
                                  </Button>|
                                  <Button
                                    variant="contained"
                                    sx={{ color: 'white' }}
                                    size="small"
                                    mt={1}
                                    onClick={() => {
                                      selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity =
                                        selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity =
                                        parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) + 1;
                                      selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].TotalPrice =
                                        parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) *
                                        parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].UnitPrice)

                                      selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].TaxAmount =
                                        selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0]?.VATInclusive ?
                                          parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) *
                                          parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].UnitPrice) * .15 : 0

                                      setSelectedItems(selectedItems.map(it => it))
                                    }}
                                  >
                                    +
                                  </Button>|
                                  <Button
                                    variant="contained"
                                    sx={{ color: 'white' }}
                                    size="small"
                                    mt={1}
                                    onClick={() => {
                                      selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity =
                                        parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) > 0 &&
                                        parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) - 1;
                                      selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].TotalPrice =
                                        parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) *
                                        parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].UnitPrice)
                                      setSelectedItems(selectedItems.map(it => it));
                                      if (parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) > 0) {
                                        selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].TaxAmount =
                                          selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0]?.VATInclusive ?
                                            parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].Quantity) *
                                            parseFloat(selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0].UnitPrice) * .15 : 0
                                      }
                                    }}
                                  >
                                    -
                                  </Button>|
                                  <Button
                                    variant="contained"
                                    sx={{ color: 'white', fontSize: 10 }}
                                    size="small"
                                    mt={1}

                                  >
                                    {"Qty: " + (selectedItems && selectedItems.length && selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))
                                      .length > 0 ?
                                      selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0]?.Quantity ?
                                        selectedItems.filter((item) => ((parseInt(item.Item) === parseInt(product.Item)) && ("Sales" === item.Type) && (item.CustomerName === customer)))[0]?.Quantity : 0 : 0)}

                                  </Button>

                                </div>

                              ) : (
                                <Button
                                  variant="contained"
                                  size="small"
                                  fullWidth
                                  onClick={() => {

                                    (selectedSalesType === null || selectedSalesType === undefined) || (!selectedSalesType && selectedSalesType.length <= 0) ?
                                      alert('Select the voucher type first') :
                                      (store === null || store === undefined) || (!store && store.length <= 0) ?
                                        alert('Select the store first') :
                                        ((selectedSalesType === "Draft" || selectedSalesType === "Request") || (customer && customer !== null && customer.length > 0)) ?
                                          addtoCart({
                                            OrderId: 0,
                                            Type: "Sales",
                                            Item: product.Item,
                                            Name: product.Name,
                                            Store: globalStores.filter(st => st.Name === store)[0]?.Id,
                                            Quantity: ((!product.DefaultOrderQty || product.DefaultOrderQty === 0) ? 1 : product.DefaultOrderQty),
                                            UnitPrice: product.Price && product.Price > 0 ? product.Price : 1,
                                            TotalPrice: product.Price * ((!product.DefaultOrderQty || product.DefaultOrderQty === 0) ? 1 : product.DefaultOrderQty),
                                            VATInclusive: product.VATInclusive,
                                            Customer: (customer && customer !== null && customer.length > 0) ? globalCustomers.filter(asup => asup.CustomerName === customer)[0]?.Customer : 0,
                                            CustomerName: customer,
                                            Supplier: globalUser.Parent,
                                            SupplierName: globalUser.ParentName,
                                            Image: product.Picture,
                                            TaxAmount: product.VATInclusive
                                              ? (product.Price && product.Price > 0 ? product.Price : 1) * ((!product.DefaultOrderQty || product.DefaultOrderQty === 0) ? 1 : product.DefaultOrderQty) * 0.15
                                              : 0,
                                          }) : alert('Select the customer first');

                                  }}
                                >
                                  {t("add cart")}
                                </Button>
                              )}
                            </Typography>
                          </>
                        ) : (
                          ""
                        )}
                        <Typography variant="body2" align="left">
                          <Button
                            variant="contained"
                            size="small"
                            fullWidth
                            sx={{

                              marginTop: 1
                            }}
                          >
                            <ProductDetails
                              icon={

                                <div>  {t("product details")}</div>

                              }

                              Products={productsList.filter(pro => pro.Item === product.Item)}
                            />
                          </Button>
                        </Typography>
                        <Tooltip title={t("favorite item")} color={theme.palette.primary.contrastText}>
                          <Rating aria-label="add to favorites">Rating:</Rating>
                        </Tooltip>
                      </CardContent>
                      {/*      sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                      }}
                        <Tooltip title={t("substitute item")} color="primary">
                          <IconButton aria-label="Substitute">
                            <FindReplaceIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Mandatory Products" color="primary">
                          <IconButton aria-label="Manadatory">
                            <CoPresentIcon />
                          </IconButton>
                        </Tooltip>
                        
                        <Tooltip title={t("share item")} color="primary">
                          <IconButton aria-label="share">
                            <ShareIcon />
                          </IconButton>
                        </Tooltip>
                      </CardActions> */}
                    </Card>
                    {/* </Badge> */}

                  </Grid>
                );
              })}
          </Grid>
        </Grid>

      </Grid>

    </Stack>
  );
}

export default LandingSalesComp;
